import React from "react"
import {Box, Container, Divider, Link, List, ListItem, ListItemButton, Typography,} from "@mui/material";
import {CmCollection, CmDownload} from "../../../../packages/graphql-layer/src";
import "../../../utility/i18n"
import CCOLoadableContainer from "../../fundamentals/CCOLoadableContainer";
import IconButton from "@mui/material/IconButton";
import DownloadIcon from '@mui/icons-material/Download';
import {bytesToSize, generateDownloadUrl} from "../../../utility/navigationUtil";
import {metaDataElementWithId, metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import {getDataType} from "../../../utility/componentUtil";

interface Props {
    cmCollection: CmCollection
    hideBottomDivider?: boolean
}

function DownloadItems(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    return (
        <CCOLoadableContainer cmCollection={props.cmCollection}
                              maxItemDisplayed={(props.cmCollection as any).downloadSettings?.downloadDesktop}
                              showMoreCount={(props.cmCollection as any).downloadSettings?.showMoreCount
                                  ?? (props.cmCollection as any).downloadSettings?.downloadDesktop}>
            <React.Fragment>
                <List sx={{width: '100%', bgcolor: 'background.paper'}}>
                    {props.cmCollection.items?.map(i => i as CmDownload).map((item: CmDownload, index: number) => {
                            return <Container key={index} {...metaDataElementWithId(isPreview, item.id)}>
                                {index === 0 ? null : <Divider/>}
                                <Link data-cypress={'downloadLink'} id={"download-" + item.id}
                                      href={generateDownloadUrl(item.id ?? '', item.title ?? '')}
                                      target="_blank"
                                      sx={{textDecoration: 'none'}}>
                                    <ListItem id={item.id} alignItems="flex-start" sx={{height: 85}}>
                                        <ListItemButton sx={{
                                            height: 69, paddingY: 4.5, '&:hover': {
                                                '& button': {
                                                    backgroundColor: 'primary.dark',
                                                },
                                                '& span, h6': {
                                                    color: 'primary.main',
                                                },
                                                backgroundColor: 'primary.contrastText'
                                            },
                                        }}>
                                            <IconButton aria-label="fingerprint" sx={{
                                                height: 50,
                                                width: 50,
                                                padding: 0,
                                                marginRight: 6,
                                                backgroundColor: "primary.main"
                                            }}>
                                                <DownloadIcon
                                                    sx={{
                                                        color: "primary.contrastText",
                                                        padding: 0,
                                                        'path':
                                                            {
                                                                height: '48!important'
                                                            }
                                                    }}/>
                                            </IconButton>
                                            <Box display={'flex'} flexDirection={'column'}>
                                                <Typography variant={'accordion'}
                                                            color={'text.primary'}
                                                            {...metaDataProperty(isPreview, 'properties.title', item.id)}>{item.title}</Typography>
                                                <Typography variant={'subtitle2'}
                                                            color={'text.primary'}>{getDataType(item.data?.contentType ?? '') + " ("
                                                    + bytesToSize(item.data?.size || 0).replace('.', ',')})</Typography>
                                            </Box>

                                        </ListItemButton>
                                    </ListItem>
                                </Link>
                                <Divider/>
                            </Container>
                        }
                    )}
                </List>
            </React.Fragment>
        </CCOLoadableContainer>
    )
}



export default DownloadItems